<template>
    <div :class="{ 'menu-overlay--visible': isVisible }"
         class="menu-overlay"
         @click="dispatchCloseMenuEvent"
    >
    </div>
</template>

<script>
    import EventBus, { events as EventBusEvents } from '@/event-bus';

    export default {
        name: 'MenuOverlay',

        data () {
            return {
                isVisible: false,
            };
        },

        mounted () {
            EventBus.$on(EventBusEvents.MENU_DROPDOWN_OPEN, this.show);
            EventBus.$on(EventBusEvents.MENU_DROPDOWN_CLOSE, this.hide);
        },

        destroyed () {
            EventBus.$off(EventBusEvents.MENU_DROPDOWN_OPEN, this.show);
            EventBus.$off(EventBusEvents.MENU_DROPDOWN_CLOSE, this.hide);
        },

        methods: {
            dispatchCloseMenuEvent () {
                EventBus.$emit(EventBusEvents.MENU_DROPDOWN_CLOSE);
            },

            show () {
                this.isVisible = true;
            },

            hide () {
                this.isVisible = false;
            },
        },
    };
</script>

<style scoped lang="scss">
    @import "~@/assets/styles/abstracts/_mixins";
    @import "~@/assets/styles/abstracts/_variables";

    @include media-breakpoint-up(lg) {
        .menu-overlay {
            @include place(0, 0, 0, 0, fixed);

            background: rgba(0, 0, 0, 0.5);

            z-index:    1;

            opacity:    0;
            visibility: hidden;

            transition: all 200ms ease-in-out;

            &--visible {
                opacity:    1;
                visibility: visible;
            }
        }
    }
</style>
